import { toggleClass } from '@splidejs/splide/src/js/utils'
import { createApp } from 'vue'

declare module 'vue' {
  interface HTMLAttributes {
    ariaExpanded?: boolean
    ariaLabel?: string
    tabIndex?: string
  }
}

export default function init(mountElement: HTMLElement) {

  const app = createApp({
    data: () => ({
      docked: false,
      toggled: false,
      toggledChildren: {}
    }),

    watch: {
      toggled(newValue) {
        if (newValue) {
          document.body.parentElement.style.overflow = 'hidden'
          document.body.style.overflow = 'hidden'
        } else {
          document.body.parentElement.style.overflow = ''
          document.body.style.overflow = ''
        }
      }
    },

    mounted() {
      let menuRect = this.$el.getBoundingClientRect()
      let itemsRect = this.$refs.items.getBoundingClientRect()
      let wrapper = this.$refs.wrapper
      let isScrolling = false

      const onScroll = () => {
        this.docked = (window.scrollY >= menuRect.height - itemsRect.height)

        this.docked ? wrapper.classList.add('!transition-none') : setTimeout(() => {
          wrapper.classList.remove('!transition-none')
        })
      }

      function scrollLoop() {
        if (isScrolling) {
          onScroll()
          isScrolling = false
        }
        requestAnimationFrame(scrollLoop)
      }

      requestAnimationFrame(scrollLoop)

      window.addEventListener('scroll', function () {
        isScrolling = true
      })
    },

    methods: {
      toggleMenu() {
        this.toggled = !this.toggled
      },

      isToggled(name) {
        return this.toggledChildren[name]
      },

      toggleChild(name) {
        this.toggledChildren[name] = !this.toggledChildren[name]
      }
    }
  })

  app.mount(mountElement)
}
